export default "__VITE_ASSET__CDFQRM$8__"